import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  ColDef,
  GridOptions,
  RowClickedEvent,
  ValueFormatterParams
} from 'ag-grid-community';
import {
  Box,
  Heading,
  useDisclosure,
  Button,
  Table,
  TableContainer,
  Tbody,
  Text,
  Link,
  Grid,
  GridItem,
  Tooltip,
  Image,
  Textarea,
  Spinner,
  Select,
} from '@chakra-ui/react';
import LOATaxStampsDatasource from '../ducks/LOATaxStampsDatasource';
import { dateFormatterInMonth, getFormattedDate, getFormattedDateTime, getFormattedDateTimeFroManualReviewedAt, getFormattedDateTimeFromReviewedAt } from '@/queue/elements/value-formatters/date-formatter.mjs';
import { LicenseConfirmation, LOAReview, ReviewConfirmation } from '@/model/license-review.mjs';
import TableElement from '@/table/TableElement';
import FFLDetailModal from '@/explore/ffl-detail/FFLDetailModal';
import { getIsGlobalAdmin } from '@/redux/app-selectors';
import AppConfig from '@/utils/app-config.mjs';
import { SERVER_PAGE_LICENSE_APPROVAL_SIZE } from '@/model/Constants';
import { agGridIconsConfig } from '@/explore/ffl-detail/utils.mjs';
import { updateLOAApprovalStatus } from '@/api/apis';
import ModalComponent from '@/common/Modal';
import { loaApprovalValidation, regexFullLicense, textareaLengthValidation } from '@/queue/ducks/validationSchema';
import PreviewLicense from '@/common/PreviewLicense';
import ConfirmationModal from '@/common/ConfirmationModal';
import ControlledInput from '@/common/ControllerInput';
import { normalizeRejectedReasonFromApi, reviewFilters, reviewRejectedReasonsFflLoa, SOURCE_OF_LICENSE, stepMapping } from '@/utils/constants';
import { getHideUnnecessaryLOARejectionValue, getLOAApprovalFilterModel, getLOAApprovalSort } from './selector';
import ReviewConfirmationModal from '@/common/ReviewConfirmationModal';
import { fixTimezoneOffset, trimDate } from '@/queue/utils';
import { MapInteractionCSS } from "react-map-interaction";
import { useSearchParams } from 'react-router-dom';
import { setIsCertificateStatusUpdated, setIsRefreshingLOAApproval, setLOAApprovalFilterModel, setLOAApprovalSearchText } from '../ducks/slice';
import { useDispatch } from 'react-redux';
import { getFormattedTextForManualReview } from '@/utils/utils';
import s3Utils from '@/utils/s3Utils';
import { callToGetDocumentStatus, callToGetLicenseRecordDetails, setDocumentsRequiredDetails } from '@/queue/ducks/slice';
import { getDocumentsRequiredDetails, getIsDealerDetailsLoading, getValidLicenseRecord } from '@/queue/ducks/selectors';
import FlatDatePickr from '@/common/Flatpickr';
interface props {
  doRefresh: number;
  tabName: string | undefined;
  className: string;
  gridRef: React.RefObject<AgGridReact<LOAReview>>;
}

interface Props {
  valueFormatted: string;
  value: string;
}

function LOAReviewTable({ doRefresh, tabName, className, gridRef }: props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isLicenseModalOpen,
    onOpen: onLicenseModalOpen,
    onClose: onLicenseModalClose
  } = useDisclosure();
  const {
    isOpen: isHyperLinkOpen,
    onOpen: onHyperLinkOpen,
    onClose: onHyperLinkClose
  } = useDisclosure();
  const [loaReview, setLoaReview] = useState<LOAReview | null>(
    null
  );
  const hideLOARejectionDocument = getHideUnnecessaryLOARejectionValue()

  const [initialLicenseData, setInitialLicenseData] =
    useState<LOAReview | null>(null);
  const {
    isOpen: isLicensePreviewOpen,
    onOpen: onLicensePreviewOpen,
    onClose: onLicensePreviewClose
  } = useDisclosure();
  const {
    isOpen: isReviewConfirmationMadalOpen,
    onClose: onCloseReviewConfirmationModal,
    onOpen: onOpenReviewConfirmationModal
  } = useDisclosure();
  const [licenseeId, setLicenseeId] = useState<string>('');
  const [downloadingFile, setDownloadingFile] = useState<boolean>(false);
  const dataSource = useMemo(() => new LOATaxStampsDatasource(), []);
  const blob = new Blob();
  const [licenseBlob, setLicenseBlob] = useState<Blob | null>(blob);
  const [reviewConfirmation, setReviewConfirmation] = useState<ReviewConfirmation>({
    header: "",
    isCancelBtnDisable: false,
    isConfirmBtnDisable: false,
    isConfirmBtnLoading: false,
    isSaveBtnLoading: false,
    rejectedReason: "",
    note: "",
    error: "",
    status: "",
  });
  const [reviewInputVal, setReviewInputVal] = useState<any>({
    rejectReason: "",
    note: "",
  });
  const loaApprovalFilterModel = getLOAApprovalFilterModel();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [downloadingFile2, setDownloadingFile2] = useState<boolean>(false);
  const loaApprovalSort = getLOAApprovalSort();

  useEffect(() => {
    if (doRefresh === 3) reFetchData();
  }, [doRefresh]);
  function renderHyperLink(data: any, columnName: string, fullLicenseKey: string | null = null) {
    let renderValue = '';
    let linkUrl = '';
    if (columnName === "full_license_key") {
      linkUrl = `/dealers-search/${data}`;
      renderValue = (data && fullLicenseKey) ? fullLicenseKey : "NONE";
    } else if (columnName === "transfer_id") {
      linkUrl = `/transfers/${data}`;
      renderValue = data || '';
    }
    const ref = (ref: any) => {
      if (!ref) return;
      ref.onclick = (e: any) => {
        e.stopPropagation();
        window.open(linkUrl, '_blank');
      };
    };
    const text = (color: string) => (
      <Text color={color}>{renderValue}</Text>
    );
    return (!renderValue || renderValue === 'NONE') ? (
      text('black')
    ) : (
      <Link ref={ref} href="#">
        {text('#0065FF')}
      </Link>
    );
  }

  const status: { [key: string]: string } = {
    "pending": "orange",
    "rejected": "red",
    "approved": "green",
  };

  function StatusCellRenderer(value: any) {
    return (
      <Box>
        <Box as={'span'} color={status[value?.data?.status] || ""} marginRight={'0.25rem'}>
          {'\u2B24'}
        </Box>
        {value?.data?.status ? (value.data.status[0].toUpperCase() + value.data.status.slice(1)) : ""}
      </Box>
    );
  }
  function ActionPerformedByCellRenderer({ data, value }:any) { 
    const actionPerformedBy: any = {
      System: 'backend',
      Agent: 'profile',
      Dealer: 'dealer',
      system: 'backend',
      agent: 'profile',
      dealer: 'dealer',
      Support: 'profile',
      support: 'profile',
      SMS: 'dealer',
      sms: 'dealer',
      email_campaign: 'email',
      ffl360: 'profile'
    }
    const email = data?.manual_review_requested_by && data?.manual_review_requested_by !==null ? data?.manual_review_requested_by : '';
    if (value && value !== null) {
      if (value?.toLowerCase() === "email_campaign") {
        return `Via Dealer ${email}`;
      }
      if (value?.toLowerCase() === "dealer" || value?.toLowerCase() === "upload_ui") {
        return `Via Dealer ${email}` ;
      }
      if (actionPerformedBy[value]) {
        return `Via ${actionPerformedBy[value]} ${email}`;
      }
      return ''
    }
    return ''
  }
  function renderBusinessName({data}: ValueFormatterParams) {
    return (
      <Box>
        {data?.business_name}
      </Box>
    );
  }
  const handleSortByChange = React.useCallback(() => {
    if (dataSource && gridRef.current?.api) {
      // Show loading overlay immediately
      gridRef.current.api.showLoadingOverlay();
      
      // Update datasource with new sortBy value
      dataSource.setSortBy(loaApprovalSort === 'true');
      
      // Refresh server-side data
      setTimeout(() => {
        gridRef.current?.api.refreshServerSide();
      }, 50); // Small delay to ensure loading overlay is visible
    }
  }, [loaApprovalSort, dataSource]);

  useEffect(() => {
    handleSortByChange();
  }, [handleSortByChange]);

  function reFetchData() {
    gridRef.current?.api?.refreshServerSide();
  }

  function SourceCellRenderer({ data }: ValueFormatterParams) {
    return (
      <Box>
        {SOURCE_OF_LICENSE[data?.source] || ''}
      </Box>
    );
  }

  const getFailedStep = (value: string | number | null) => {
    if (value == null || value === '') return '';
    return stepMapping[String(value)] || '';
  };

  const columnDefs: ColDef[] = [
    {
      field: 'transfer_id',
      headerName: 'Transfer ID',
      cellRenderer: ({ value, valueFormatted }: Props) => renderHyperLink(value, "transfer_id"),
      width: 240,
      suppressSizeToFit: true
    },
    {
      field: 'full_license_key',
      headerName: 'License Number',
      valueFormatter: ({ data }: ValueFormatterParams<LOAReview>) => {
        if (data?.full_license_key) {
          return data?.full_license_key;
        }
        return 'NONE';
      },
      cellRenderer: (data: any) => renderHyperLink(data?.data?.dealer_id, "full_license_key", data?.valueFormatted),
      width: 200,
      suppressSizeToFit: true
    },
    {
      field: 'business_name',
      headerName: 'Business Name',
      cellRenderer: renderBusinessName,
      width: 350,
      suppressSizeToFit: true
    },
    {
      field: 'status',
      headerName: 'Status',
      cellRenderer: StatusCellRenderer,
      width: 200,
      filter: "agSetColumnFilter",
      filterParams: {
        values: reviewFilters.status.map((item: any) => item.value),
      },
      suppressSizeToFit: true
    },
    {
      field: 'reviewed_at',
      headerName: 'Review Date',
      valueFormatter: getFormattedDateTimeFromReviewedAt,
      width: 250,
      suppressSizeToFit: true
    },
    {
      field: 'reviewed_by',
      headerName: 'Reviewer',
      cellRenderer: ({ data }: ValueFormatterParams) => {
        return (
          <Box>
            {data?.reviewed_by ? data?.reviewed_by : ""}
          </Box>
        );
      },
      width: 250,
      suppressSizeToFit: true
    },
    {
      field: 'source',
      headerName: 'Source of LOA',
      cellRenderer: SourceCellRenderer,
      width: 240,
      filter: "agSetColumnFilter",
      filterParams: {
        values: reviewFilters.source.map((item: any) => item.value),
      },
      suppressSizeToFit: true
    },
    {
      field: 'created_by',
      headerName: 'Uploaded By',
      cellRenderer: ({ data }: ValueFormatterParams) => {
        return data?.source === 'ffl360' ? (data?.created_by || '-') : '-';
      },
      width: 200,
      suppressSizeToFit: true
    },
     {
      field: 'created_at',
      headerName: 'Uploaded Date',
      valueFormatter: ({ data }: ValueFormatterParams) => {
        const date = data?.created_at ? data["created_at"] : null
        return dateFormatterInMonth(date);
      },
      width: 250,
      filter: 'agDateColumnFilter',
      filterParams: {
        includeBlanksInRange: true
      },
      suppressSizeToFit: true
    },
    {
      field: 'updated_at',
      headerName: 'Updated Date',
      valueFormatter: ({ value }: { value: string }) => {
        return dateFormatterInMonth(value) || '';
      },
      width: 250,
      suppressSizeToFit: true
    },
    {
      field: 'error_code',
      headerName: 'Failure Reason',
      cellRenderer: ({ value }: { value: string }) => {
        if (value) return getFailedStep(value) || '';
        else return '';
      },
      width: 350,
      filter: "agSetColumnFilter",
      filterParams: {
        values: [...reviewFilters.loaFailedSteps.map((item: any) => item.value), "other"],
      },
      suppressSizeToFit: true
    },
    {
      field: 'rejected_reason',
      headerName: 'Rejection Reason',
      cellRenderer: ({ value }: { value: string | null | undefined }) => {
        return normalizeRejectedReasonFromApi(value ?? null) || '';
      },
      width: 350,
      suppressSizeToFit: true
    },
    {
      field: 'note',
      headerName: 'Rejection Note',
      cellRenderer: ({ value }: { value: string }) => {
        return value || '';
      },
      width: 350,
      tooltipField: 'note',
      suppressSizeToFit: true
    },
    {
      field: 'reference_id',
      headerName: 'Order ID',
      cellRenderer: ({ value, valueFormatted }: Props) => {
        return value || '';
      },
      width: 240,
      filter: 'agTextColumnFilter',
      suppressSizeToFit: true
    },
    {
      field: 'store_name',
      headerName: 'Store Name',
      cellRenderer: ({ value }: Props) => value || '',
      width: 240,
      suppressSizeToFit: true
    },
    {
      field: 'action_performed_by',
      headerName: 'Manual Review Requester',
      cellRenderer: ActionPerformedByCellRenderer,
      width: 300,
      suppressSizeToFit: true
    },
    {
      field: 'manual_review_requested_at',
      headerName: 'Manual Review Request Date',
      cellRenderer: getFormattedDateTimeFroManualReviewedAt,
      width: 300,
      suppressSizeToFit: true
    },
    {
      field: 'searchText',
      hide: true,
      filter: 'agTextColumnFilter',
      suppressSizeToFit: true
    },
    {
      field: 'is_external',
      headerName: 'Store Type',
      cellRenderer: ({ value, valueFormatted }: Props) => {
        if (['true'].includes(`${value}`)) return 'Live';
        else if (['false'].includes(`${value}`)) return 'Testing';
        else return '';
      },
      width: 200,
      filter: "agSetColumnFilter",
      filterParams: {
        values: [...reviewFilters.storeType.map((item: any) => item.value), 'false'],
      },
      suppressSizeToFit: true
    },
    {
      field: 'path',
      headerName: 'File Path',
      cellRenderer: ({ value }: Props) => value || '',
      width: 350,
      hide: true,
      suppressSizeToFit: true
    },
  ];
  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      sortable: true,
      filter: true,
    }),
    []
  );

  const fullURL = (path: string) => `${AppConfig.SOTTaxStampsBaseURL}${encodeURIComponent(path)}`;

  function onCloseLicensePreview() {
    setDownloadingFile(false);
    const blob = new Blob();
    setLicenseBlob(blob);
    onLicensePreviewClose();
  }
  const gridStyle = useMemo(() => ({ width: '100%' }), []);

  const gridOptions: GridOptions<LOAReview> = {
    rowModelType: 'serverSide',
    pagination: true,
    paginationPageSize: SERVER_PAGE_LICENSE_APPROVAL_SIZE,
    cacheBlockSize: SERVER_PAGE_LICENSE_APPROVAL_SIZE,
    serverSideDatasource: dataSource,
    // // generate a unique ID for each row based on the abuse ID
    getRowId: (params: any) => {
      return params.data.id;
    },
    getRowStyle: (params) => {
      if (params.data?.action_performed_by !== null &&
        params.data?.action_performed_by !== undefined &&
        params.data?.manual_review_requested_at !== null &&
        params.data?.manual_review_requested_at !== undefined &&
        params?.data?.status === 'pending'
      ) {
        return { 'background-color': 'rgba(255, 0, 0, 0.15)' };
      }
    },
    // column definitions
    columnDefs,
    defaultColDef,

    // row options
    animateRows: true,
    suppressRowClickSelection: true,
    onRowClicked: (event: RowClickedEvent<LOAReview>) => {
      if (gridRef.current && event.node) {
        gridRef.current.api.deselectAll();
        event.node.setSelected(true);
      }
    },
    onRowDoubleClicked: (event: RowClickedEvent<LOAReview>) => {
      setReviewInputVal({
        rejectReason:  "",
        note: "",
      })
      if (event.data) {
        setLoaReview({
          ...event?.data,
          issue_date: (event?.data?.issue_date ? getFormattedDate(trimDate(event.data.issue_date)) : "") as string,
          expiry_date: (event?.data?.expiry_date ? getFormattedDate(trimDate(event?.data?.expiry_date)) : "") as string,

        })
        setReviewInputVal({
          rejectReason: normalizeRejectedReasonFromApi(event.data?.rejected_reason ?? null) || "",
          note: event.data?.note || "",
        })
        setInitialLicenseData(event.data);
        // onOpen();
        window.open(`/admin/loa-approval/${event.data?.id as string}`, '_blank');
      }
    },

    // cell detail options
    suppressCellFocus: true,
    // misc options
    debug: false,
    onGridReady(params) {
      params.api.sizeColumnsToFit();
      params.api.setFilterModel({
        ...(!searchParams.get('transferId') ?
          {
            "status": {
              ...loaApprovalFilterModel?.status,
              values: ["pending"]
            },
            "is_external": {
              ...loaApprovalFilterModel?.storeType,
              values: ["true"]
            }
          }
          : {
            searchText: {
              ...loaApprovalFilterModel.searchText,
              filter: searchParams.get('transferId') || ''
            }
          }),
      });
    },
    icons: agGridIconsConfig,
    overlayNoRowsTemplate:
      '<div class="not-found-box"><img src="/images/ui/not-found-icon.png"></img><p class="not-found-box__title">No LOA found</p><p class="not-found-box__message">Try adjusting your filter to find what you’re looking for</p></div>'
  };

  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      const checkDataAvailability = () => {
        const rowCount = gridRef?.current?.api.getDisplayedRowCount();
        if (rowCount) gridRef.current?.api.hideOverlay();
        else gridRef.current?.api.showNoRowsOverlay();
      };

      checkDataAvailability();
      gridRef.current.api.addEventListener('modelUpdated', checkDataAvailability);

      return () => {
        gridRef?.current?.api.removeEventListener('modelUpdated', checkDataAvailability);
      };
    }
  }, [gridRef?.current?.api]);

  const previousFilterModel = useRef<any>(null);

  useEffect(()=>{
    reFetchData()
  },[hideLOARejectionDocument])

  useEffect(() => {
    if (gridRef.current && gridRef.current?.api) {
      gridRef.current?.api?.setFilterModel({
        ...loaApprovalFilterModel,
        "error_code": loaApprovalFilterModel?.faildSteps,
        "is_external": loaApprovalFilterModel?.storeType,
        "isManuallyRequested": loaApprovalFilterModel?.isManuallyRequested,
        "created_at":
          (loaApprovalFilterModel?.created_date_time?.dateFrom &&
            loaApprovalFilterModel?.created_date_time?.dateTo) &&
            new Date(loaApprovalFilterModel?.created_date_time?.dateFrom) <=
            new Date(loaApprovalFilterModel?.created_date_time?.dateTo)
            ? loaApprovalFilterModel?.created_date_time
            : {}
      });
      
      const newContext: any = {
          customFilters: {
            hideRejection: !hideLOARejectionDocument
          }
        };
      if (loaApprovalFilterModel?.isManuallyRequested) {
        previousFilterModel.current = loaApprovalFilterModel;
        newContext.customFilters.isManuallyRequested = loaApprovalFilterModel?.isManuallyRequested?.values || []
        };

        // Update grid context
        gridRef.current.api.setGridOption('context', newContext);
        gridRef.current?.api?.refreshServerSide();

    }
  }, [loaApprovalFilterModel, gridRef.current?.api, searchParams.has("transferId"), hideLOARejectionDocument])

  useEffect(() => {
    if (searchParams.get('transferId') && tabName === 'loa-approval') {
      dispatch(setLOAApprovalSearchText(searchParams.get('transferId') || ''));
      dispatch(
        setLOAApprovalFilterModel({
          ...loaApprovalFilterModel,
          status: {
            ...loaApprovalFilterModel.status,
            values: []
          },
          searchText: {
            ...loaApprovalFilterModel.searchText,
            filter: searchParams.get('transferId') || ''
          },
        })
      );
    } else {
      dispatch(setLOAApprovalSearchText(''));
      dispatch(
        setLOAApprovalFilterModel({
          ...loaApprovalFilterModel,
          status: {
            ...loaApprovalFilterModel.status,
            values: ['pending']
          },
          searchText: {
            ...loaApprovalFilterModel.searchText,
            filter: ''
          },
        })
      );
    }
  }, [searchParams])

  const isSuperAdmin = getIsGlobalAdmin();

  function renderData() {
    return (
      <FFLDetailModal
        id={licenseeId}
        isOpen={isHyperLinkOpen ? isHyperLinkOpen : isLicenseModalOpen}
        onClose={isHyperLinkOpen ? onHyperLinkClose : onLicenseModalClose}
        cognitoGroup={false}
        isSuperAdmin={isSuperAdmin}
      />
    );
  }

  const endDateSpecialTaxPickerRef = useRef<any>(null);

  const openEndDateSpecialTaxDatePicker = () => {
    if (endDateSpecialTaxPickerRef.current) {
      endDateSpecialTaxPickerRef.current.setOpen(true);
    }
  };

  const convertLicenseInEightDigits = (value: string) => value ? `${value[0]}${value.slice(2, 4)}${value.slice(15)}` : "";

  const checkStatus = (currentStatus: string | undefined, status: string) => {
    return currentStatus === status;
  };

  const onDateChange = async (date: Date, fieldName: string) => {
    console.log({ fieldName: getFormattedDate(date.toDateString()) });

    setLoaReview((prevState: any) => ({
      ...prevState,
      [fieldName]: getFormattedDate(date.toDateString()),
      "expiry_date": getFormattedDate(date.toDateString(), (prevState?.number_of_months || 6)),
      errors: { ...(prevState.errors || {}), [fieldName]: '' }
    }));
  }

  const onOpenCertificateStatus = async (status: string) => {
    if (status === "approved") {
      await validateFields();
      setReviewConfirmation((prevState: any) => ({
        ...prevState,
        header: "Reason of Approval",
        status: status
      }))
    } else {
      setReviewConfirmation((prevState: any) => ({
        ...prevState,
        header: "Reason of Rejection",
        status: status
      }))
    }
    onOpenReviewConfirmationModal();
  }

  const updateCertificateStatus = async (status: string, isSaveClicked:boolean=false, isEmailIgnored:boolean=false) => {
    try {
      setReviewConfirmation((prevState: ReviewConfirmation) => ({
        ...prevState,
        isConfirmBtnLoading: !isSaveClicked ? true : isSaveClicked,
        isCancelBtnDisable: true,
        isSaveBtnLoading: isSaveClicked,
      }));
      const response = await updateLOAApprovalStatus({
        id: loaReview?.id,
        license_key: regexFullLicense.test(loaReview?.license_key as string) ? convertLicenseInEightDigits(loaReview?.license_key || "") : loaReview?.license_key,
        dealer_id: loaReview?.dealer_id,
        issue_date: loaReview?.issue_date,
        expiry_date: loaReview?.expiry_date,
        path: loaReview?.path,
        loa_type: loaReview?.loa_type,
        status: status,
        rejected_reason: reviewConfirmation?.rejectedReason,
        note: reviewConfirmation?.note,
        source: loaReview?.source,
        ignoreManualReviewEmail: isEmailIgnored
      });
      if (response.status === 204) {
        dispatch(setIsCertificateStatusUpdated(true));
        reFetchData();
      }
      closeReviewConfirmationModal();
      onClose();
    } catch (err: any) {
      console.log('ERROR', err);
      if (
        err &&
        err?.response &&
        err.response?.status == 404 &&
        err.response?.data &&
        err.response.data?.Error
      ) {
        setLoaReview((prevState: any) => ({
          ...prevState,
          errors: { ...(prevState.errors || {}), 'license_key': err.response.data?.Error }
        }))
      }
    } finally {
      setReviewConfirmation((prevState: ReviewConfirmation) => ({
        ...prevState,
        isConfirmBtnLoading: false,
        isCancelBtnDisable: false,
        isSaveBtnLoading: false,
      }));
    }
  };

  const validateFields = async () => {
    try {
      await loaApprovalValidation.validate(loaReview, { abortEarly: false });
    } catch (error: any) {
      if (error.errors && error.errors.length > 0) {
        const errors = error?.inner?.reduce((acc: { [key: string]: string }, err: any) => {
          acc[err.path] = err.message;
          return acc;
        }, {});
        setLoaReview((prevState: any) => ({
          ...prevState,
          errors
        }));
        throw new Error(error?.errors[0]);
      }
    }
  };

  const validateField = async (name: string, value: string | Date) => {
    try {
      await loaApprovalValidation.validateAt(name, { [name]: value });
      setLoaReview((prevState: any) => ({
        ...prevState,
        errors: { ...(prevState.errors || {}), [name]: '' }
      }));
    } catch (error: any) {
      if (error.errors && error.errors.length > 0) {
        setLoaReview((prevState: any) => ({
          ...prevState,
          errors: { ...(prevState.errors || {}), [name]: error.errors[0] }
        }));
      }
    }
  };

  const onChangeInputs = async (value: string | number, fieldName: string) => {
    if (fieldName === "number_of_months" && value && String(value)?.length > 2) return;
    await validateField(fieldName, value as string);
    if (loaReview?.issue_date && fieldName === "number_of_months") {
      setLoaReview((prevState: any) => ({
        ...prevState,
        [fieldName]: value,
        "expiry_date": getFormattedDate(prevState?.issue_date, (value || 6) as number)
      }));
      return;
    }
    setLoaReview((prevState: any) => ({
      ...prevState,
      [fieldName]: value
    }));
  };

  const handleDownload = async () => {
    const url = fullURL(loaReview?.path || "");
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = loaReview?.path?.split("/").pop() || "";
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the image:', error);
    }
  };

  const handleChange = async (event: any) => {
    setReviewConfirmation((prevState: ReviewConfirmation) => ({
      ...prevState,
      rejectedReason: event.target.value
    }));
  };

  const handleTextChange = async (event: any) => {
    const value = event.target.value;
    try {
      await textareaLengthValidation.validateAt('textarea', { 'textarea': value });
      setReviewConfirmation((prevState: ReviewConfirmation) => ({
        ...prevState,
        note: event.target.value,
        error: ''
      }));
    } catch (error: any) {
      if (error.errors && error.errors.length > 0) {
        setReviewConfirmation((prevState: ReviewConfirmation) => ({
          ...prevState,
          error: error.errors[0]
        }));
      }
    }
  };

  const closeReviewConfirmationModal = () => {
    onCloseReviewConfirmationModal();
    setReviewConfirmation({
      header: "",
      isCancelBtnDisable: false,
      isConfirmBtnDisable: false,
      isConfirmBtnLoading: false,
      isSaveBtnLoading: false,
      rejectedReason: "",
      note: "",
      error: "",
      status: "",
    });
  }
  const [dealer_id, setDealerId] = useState<string>('');
  const disableConfirmButton = () => {
    if (reviewConfirmation.error || (reviewConfirmation.status === "rejected" && !reviewConfirmation.rejectedReason)) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    if (isOpen) {
      dispatch(setDocumentsRequiredDetails({}));
    }
  }, [isOpen]); 

  useEffect(()=> {
    if(loaReview?.dealer_id){
      setDealerId(loaReview?.dealer_id || '')
    }
  }, [loaReview?.dealer_id]);

  useEffect(() => {
    if(loaReview?.license_key && (loaReview?.license_key?.length === 8 || loaReview?.license_key?.length === 20) && isOpen == true ){
      dispatch(callToGetLicenseRecordDetails({ id: loaReview?.license_key }));
    }
    else{
      dispatch(setDocumentsRequiredDetails({}));
      setDealerId('');
    }
  }, [loaReview?.license_key, isOpen]);

  const validLicenseRecordDetails = getValidLicenseRecord()

  useEffect(() => {
    if (validLicenseRecordDetails?.dealerId && validLicenseRecordDetails?.fullLicenseKeys?.[0]) {
      dispatch(callToGetDocumentStatus({ id: validLicenseRecordDetails?.fullLicenseKeys?.[0] }));
      setDealerId(validLicenseRecordDetails?.dealerId);
    }
    else{
      setLoaReview((prevState: any) => ({
        ...prevState,
        errors: { ...(prevState?.errors || {}), 'license_key': 'Enter valid license number' }
      }))
      dispatch(setDocumentsRequiredDetails({}));
      setDealerId('');
    } 
  }, [validLicenseRecordDetails]);

  const documentsRequiredDetails = getDocumentsRequiredDetails()
  const isDealerDetailsLoading = getIsDealerDetailsLoading();

  const downloadFile2 = async (path: string) => {
    setDownloadingFile2(true);
    await s3Utils.getFile(path, "licenseReader", { public: '' });
    setDownloadingFile2(false);
  };


  const downloadIcon2 = () => {
    return (
      <>
        {downloadingFile2 ? (
          <button className="license_details__download-btn download-license-height">
            <Spinner size="sm" />
          </button>
        ) : (
          <Box
            display={'inline'}
            position={'relative'}
            top={'6px'}
            pl={2}
          >
          <Tooltip
            hasArrow
            placement="top"
            label="Download Original LOA"
            color={'black'}
            bg={'white'}
          >
            <button
              className="license_details__download-btn download-license-height"
              onClick={() => downloadFile2(loaReview?.object_path as string)}
              disabled={!loaReview?.object_path}
            >
              <Image src="/images/ui/download.svg" />
            </button>
          </Tooltip>
          </Box>
        )}
      </>
    );
  };

  const downloadIcon = () => {
    return <Box
      display={'inline-block'}
      position={'relative'}
      top={'6px'}
      pl={2}
      cursor={'pointer'}
      onClick={handleDownload}
    >
      <Tooltip
        hasArrow
        placement="top"
        label="Download certificate"
        color={'black'}
        bg={'white'}
      >
        <Image src="/images/ui/download.svg" mr={2} />
      </Tooltip>
      {/* {licenseReview?.license_path?.split("/").pop() || ""} */}
    </Box>
  }

  const onSave = async() => {
    await validateFields();
    await updateCertificateStatus(loaReview?.status ? loaReview?.status.toLowerCase() : "pending", true) 
  }

  return (
    <>
      {renderData()}
      <Heading size={'md'} paddingBottom={'20px'}>
        LOA Approval
      </Heading>
      <div style={gridStyle} className={className}>
        <AgGridReact
          className={'ag-theme-alpine'}
          ref={gridRef}
          gridOptions={gridOptions}
        />
      </div>
      <ModalComponent onClose={() => {
        setLoaReview((prevState: any) => ({
          ...prevState,
          license_key: null,
          business_name: null,
          position_title: null,
          errors: {}
        }))
        onClose();
      }}
        isOpen={isOpen}
        title={<>LOA Approval</>}
        variant={2}
        className="loa-tax-stamps-modal"
        padding={'25px !important'}
        footer={
          <>
          <Button 
              background= "#0C1E46"
               colorScheme= "blue"
              padding="8px 20px"
              marginRight="20px"
              isLoading={reviewConfirmation.isSaveBtnLoading}
              sx={{outline: 'none !important'}}
              isDisabled={(loaReview &&
                loaReview?.errors &&
                Object.values(loaReview?.errors).some((val) => val !== '') ? true : false)}
              onClick={() => { onSave()}}
            >
              Save
            </Button>
            <Button
              {...(checkStatus(loaReview?.status, "approved") && { leftIcon: <Image src="/images/ui/success.svg" />, isDisabled: true })}
              {...(!checkStatus(loaReview?.status, "pending") ? { colorScheme: "green", variant: 'outline' } : { background: "#0C1E46", colorScheme: "blue" })}
              padding="8px 20px"
              marginRight="20px"
              sx={{outline: 'none !important'}}
              onClick={() => { onOpenCertificateStatus("approved") }}
            >
              {!checkStatus(loaReview?.status, "approved") ? "Approve" : "Approved"}
            </Button>
            <Button
              {...(checkStatus(loaReview?.status, "rejected") && { leftIcon: <Image src="/images/ui/reject.svg" />, isDisabled: true })}
              {...(!checkStatus(loaReview?.status, "pending") ? { colorScheme: "red", variant: 'outline', padding: "8px 20px" } : { background: "#ffffff", color: "#0C1E46", colorScheme: "blue", border: "1px solid #0C1E46", padding: "8px 11px" })}
              onClick={() => { onOpenCertificateStatus("rejected") }}
              marginRight="20px"
              sx={{outline: 'none !important'}}
            >
              {!checkStatus(loaReview?.status, "rejected") ? "Reject" : "Rejected"}
            </Button>
            <Button
              colorScheme="blue"
              background="#ffffff"
              color="#0C1E46"
              border="1px solid #0C1E46"
              padding="8px 11px"
              onClick={onClose}
              sx={{outline: 'none !important'}}
            >
              Cancel
            </Button>
          </>
        }
      >
        <div className='approval-model-body'>
          <Grid templateColumns={{ base: '1fr', xl: 'repeat(2, 1fr)' }} gap={6}>
            <GridItem>
              <TableContainer className='loa-table-container' flex={1}>
                <Table>
                  <Tbody>
                    <Grid
                      templateRows='repeat(1, 1fr)'
                      templateColumns='repeat(1, 1fr)'
                      columnGap={6}
                    >
                        <Grid
                            templateRows='50px'
                            templateColumns='repeat(1, 1fr)'
                        >
                            <GridItem>
                                <TableElement noBorder={true} label={ <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  License Number:
                                  {(dealer_id) && (
                                    <img  
                                      src="/images/ui/blue-link.svg" 
                                      alt="License" 
                                      onClick={(e) => { 
                                        e.stopPropagation(); 
                                        window.open(`/dealers-search/${dealer_id}`, '_blank'); 
                                      }} 
                                      style={{ 
                                        width: '16px', 
                                        height: '16px', 
                                        cursor: 'pointer'
                                      }} 
                                    />
                                  )}
                                  
                                </div>} px={"0"} />
                            </GridItem>
                            <GridItem>
                              <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                                <ControlledInput
                                  className="loa-tax-stamp__input contact-detail-form__contact-name"
                                  type="text"
                                  placeholder="XXXXXXXX or X-XX-XXX-XX-XX-XXXXX"
                                  value={loaReview?.license_key || ""}
                                  onChange={(event: any) =>
                                      onChangeInputs(
                                      event.target.value ? event.target.value?.trim() : "",
                                      'license_key'
                                      )
                                  }
                                />
                                { isDealerDetailsLoading && (
                                      <Spinner 
                                        size="sm" 
                                        style={{ 
                                          position: 'absolute',
                                          right: '8px',
                                          top: '25%',
                                          transform: 'translateY(-50%)',
                                          pointerEvents: 'none'
                                        }}
                                      />
                                    )}
                              </div>
                                {loaReview?.errors && loaReview?.errors?.license_key ?
                                  <div className="">
                                    <div className="edit-error">
                                      {loaReview.errors && loaReview?.errors.license_key && (
                                        <>* {loaReview?.errors.license_key}</>
                                      )}
                                    </div>
                                  </div> : ""
                                }
                            </GridItem>
                        </Grid>
                        <Grid
                            templateRows='50px'
                            templateColumns='repeat(1, 1fr)'
                        >
                            <GridItem>
                                <TableElement noBorder={true} label={'Issue Date:'} px={"0"} />
                            </GridItem>
                            <GridItem>
                                <FlatDatePickr
                                    label=""
                                    value={fixTimezoneOffset(loaReview?.issue_date as any) || null}
                                    onDateChange={(date: Date) => onDateChange(date, 'issue_date')}
                                    options={{ placeholderText: '-Issue Date-' }}
                                    classNameValue="transfer-form__input order-date-picker"
                                />
                                {loaReview?.errors && loaReview?.errors?.issue_date ?
                                <div className="">
                                    <div className="edit-error">
                                    {loaReview.errors && loaReview?.errors.issue_date && (
                                        <>* {loaReview?.errors.issue_date}</>
                                    )}
                                    </div>
                                </div> : ""
                                }
                            </GridItem>
                        </Grid>
                        <Grid
                            templateRows='50px'
                            templateColumns='repeat(1, 1fr)'
                        >
                            <GridItem>
                                <TableElement noBorder={true} label={'Number of Months:'} px={"0"} />
                            </GridItem>
                            <GridItem>
                                <ControlledInput
                                  className="loa-tax-stamp__input contact-detail-form__contact-name"
                                  type="number"
                                  placeholder="6"
                                  value={loaReview?.number_of_months || ""}
                                  onChange={(event: any) =>
                                      onChangeInputs(
                                      event.target.value ? event.target.value?.trim() : "",
                                      'number_of_months'
                                      )
                                  }
                                  maxWidth={"100%"}
                                />
                            </GridItem>
                        </Grid>
                        <Grid
                            templateRows='50px'
                            templateColumns='repeat(1, 1fr)'
                        >
                            <GridItem>
                                <TableElement noBorder={true} label={'Expiry Date:'} px={"0"} />
                            </GridItem>
                            <GridItem>
                                <FlatDatePickr
                                    label=""
                                    value={fixTimezoneOffset(loaReview?.expiry_date as any) || null}
                                    onDateChange={(date: Date) => onDateChange(date, 'issue_date')}
                                    options={{ placeholderText: '-Expiry Date-', disabled: true }}
                                    classNameValue="transfer-form__input order-date-picker"
                                />
                                {loaReview?.errors && loaReview?.errors?.expiry_date ?
                                <div className="">
                                    <div className="edit-error">
                                    {loaReview.errors && loaReview?.errors.expiry_date && (
                                        <>* {loaReview?.errors.expiry_date}</>
                                    )}
                                    </div>
                                </div> : ""
                                }
                            </GridItem>
                        </Grid>
                        {loaReview?.action_performed_by && (
                        <Grid
                            templateRows='50px'
                            templateColumns='repeat(1, 1fr)'
                        >
                            <GridItem>
                                <TableElement noBorder={true} label={'Manual Review Requested By:'} px={"0"} />
                            </GridItem>
                            <GridItem>
                              <Box>{loaReview?.action_performed_by
                        ? getFormattedTextForManualReview(loaReview?.action_performed_by, loaReview?.manual_review_requested_by) : ''}</Box>
                            </GridItem>
                        </Grid>
                        )}
                        {loaReview?.manual_review_requested_at && (
                        <Grid
                            templateRows='50px'
                            templateColumns='repeat(1, 1fr)'
                        >
                            <GridItem>
                                <TableElement noBorder={true} label={'Manual Review Requested At:'} px={"0"} />
                            </GridItem>
                            <GridItem>
                              <Box>{loaReview?.manual_review_requested_at
                        ? getFormattedDateTime(loaReview?.manual_review_requested_at  ) : ''}</Box>
                            </GridItem>
                        </Grid>
                        )}
                        <Grid
                            templateRows='50px'
                            templateColumns='repeat(1, 1fr)'
                        >
                            <GridItem>
                                <TableElement noBorder={true} label={'Rejection Reason:'} px={"0"} />
                            </GridItem>
                            <GridItem>
                            <Select
                                      placeholder='Select reason*' 
                                      my={3}
                                      onChange={(event) =>{
                                         setReviewConfirmation({
                                           ...reviewConfirmation,
                                           rejectedReason: event.target.value,
                                         })
                                        setReviewInputVal({...reviewInputVal, rejectReason: event.target.value})
                                      }}
                                      disabled={!checkStatus(loaReview?.status, "rejected")}
                                      required
                                   >{
                                       Object.entries(reviewRejectedReasonsFflLoa).map(([key, val]) => <option value={val as string} selected={val === reviewInputVal?.rejectReason}>{val as string}</option>)
                                    }
                            </Select>
                            </GridItem>
                        </Grid>
                        {!checkStatus(loaReview?.status, "pending") && <Grid
                            templateRows='50px auto'
                            templateColumns='repeat(1, 1fr)'
                        >
                            <GridItem>
                                <TableElement noBorder={true} label={'Note:'} px={"0"} />
                            </GridItem>
                            <GridItem>
                                <Textarea
                                  // isDisabled={true}
                                  name="rejected_reason"
                                  className="sot-transfer-form__textarea"
                                  value={reviewInputVal?.note || ""}
                                  onChange={(e) => {
                                      setReviewConfirmation({
                                        ...reviewConfirmation,
                                        note: e.target.value,
                                      })
                                      setReviewInputVal({
                                        ...reviewInputVal,
                                        note: e.target.value,
                                      })
                                  }}
                                />
                            </GridItem>
                        </Grid>}
                    </Grid>
                  </Tbody>
                </Table>
              </TableContainer>
            </GridItem>
            <GridItem>
              <TableContainer flex={1}>
                <Table>
                  <Tbody>
                    <Grid
                      templateRows='repeat(1, 1fr)'
                      pb={10}
                    >
                      {loaReview?.object_path ? <Grid
                        templateRows='60px'
                      >
                        <GridItem>
                          {/* <TableElement noBorder={true} label={'LOA Preview:'} px={"0"} renderFunction={downloadIcon} /> */}
                          <TableContainer>
                            <Table>
                              <Tbody display='flex' justifyContent='space-between' alignItems='center'>
                                <Box className="transfer_flex_row" sx={{ gap: '8px', marginTop: '8px' }}>
                                  <Box className={`doc_box ${documentsRequiredDetails.hasValidCertificate ? 'doc_active' : ''}`}>FFL License</Box>
                                  <Box className={`doc_box ${documentsRequiredDetails?.hasValidSOT ? 'doc_active' : ''}`}>SOT</Box>
                                  <Box className={`doc_box ${documentsRequiredDetails?.hasValidLOA ? 'doc_active' : ''}`}>LOA</Box>
                                </Box>
                                <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                                  <TableElement
                                    label={'LOA Preview:'}
                                    className="license-file-path"
                                    renderFunction={downloadIcon}
                                  ></TableElement>
                                  <TableElement
                                    label={'Original File'}
                                    className="license-file-path"
                                    renderFunction={downloadIcon2}
                                  ></TableElement>
                                </div>
                              </Tbody>
                            </Table>
                          </TableContainer>
                        </GridItem>
                      </Grid> : <></>}
                      <Grid
                        templateRows='auto'
                        templateColumns='repeat(1, 1fr)'
                      >
                        <GridItem
                          w={"100%"}
                          h={'auto'}
                        >
                          {
                            loaReview?.path && !(loaReview?.path.split('.').pop() === 'pdf') ?
                              <MapInteractionCSS
                                showControls
                                defaultValue={{
                                  scale: 1,
                                  translation: { x: 0, y: 20 }
                                }}
                                minScale={0.5}
                                maxScale={3}
                                translationBounds={{
                                  xMax: 400,
                                  yMax: 200
                                }}
                                btnClass={'map-interection-buttons'}
                              >
                                <Image src={loaReview?.path ? fullURL(loaReview?.path) : ""} alt='loa-image' className='loa-image' />
                              </MapInteractionCSS> :
                              <iframe src={loaReview?.path ? fullURL(loaReview?.path) : ""} name={"LOA License Preview"} title={"LOA License Preview"} id='loa-license-iframe' className='loa-license-preview'></iframe>
                          }
                        </GridItem>
                      </Grid>
                    </Grid>
                  </Tbody>
                </Table>
              </TableContainer>
            </GridItem>
          </Grid>
        </div>
      </ModalComponent>
      <ReviewConfirmationModal
        isOpen={isReviewConfirmationMadalOpen}
        onClose={() => {
          setReviewConfirmation({
            ...reviewConfirmation,
            rejectedReason: '',
            note: '',
            error: '',
          })
          closeReviewConfirmationModal()
        }}
        modalHeader={reviewConfirmation.header}
        isCancelBtnDisable={reviewConfirmation.isCancelBtnDisable}
        isConfirmBtnDisable={disableConfirmButton()}
        isConfirmBtnLoading={reviewConfirmation.isConfirmBtnLoading}
        onClickConfirmBtn={(isEmailIgnored) => { updateCertificateStatus(reviewConfirmation.status, true, isEmailIgnored) }}
        fields={reviewRejectedReasonsFflLoa}
        selectedValue={reviewConfirmation.rejectedReason}
        handleChange={handleChange}
        handleTextChange={handleTextChange}
        hideDropdown={reviewConfirmation.status !== "approved"}
        error={reviewConfirmation.error}
        approvalDetails={loaReview}
      />
      <PreviewLicense
        isOpen={isLicensePreviewOpen}
        onClose={onCloseLicensePreview}
        onOpen={onLicensePreviewOpen}
        blob={licenseBlob}
        title={'License Preview'}
        filePath={loaReview?.path as string}
      />
    </>
  );
}

export default LOAReviewTable;
